import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISiteNamedUserModel } from '@apps-common/types/portal/users'

export const QUERY_MY_MONITORING_GET_SITE_ZONE = (zoneId?: number) => ['getMyMonitoringSiteZone', zoneId].filter(Boolean)

const getSiteZone = async (zoneId?: number): Promise<ISiteNamedUserModel> =>
  axios.get(`/my-monitoring/sites/GetZone?zoneId=${zoneId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSiteZone

type Props = {
  config?: QueryConfig<QueryFnType>
  zoneId?: number
}

export const useMyMonitoringGetSiteZone = ({ config, zoneId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MY_MONITORING_GET_SITE_ZONE(zoneId),
    queryFn: () => getSiteZone(zoneId)
  })
